import type { IBaseAttributes, TConstraints } from '@feathr/rachis';
import { Model } from '@feathr/rachis';

import { REGEX_INPUT_VALIDATION } from '../global';
import { triggerableMailingConstraints } from './mailing';
import type { IMailrailDripStep } from './types';

/*
 * Steps are persisted inside the parent MailrailDripEmailCampaign, not as their own
 * API resource, so this model carries no collection/endpoint. It is instantiated
 * ephemerally to validate a single step's fields through the shared triggerable-email
 * constraints (the campaign document itself is step 0 and validates via its own chain).
 * Intersecting with IBaseAttributes satisfies Model's generic bound; step data keys on
 * step_id rather than id, and validation never touches id.
 */
export class MailrailDripStep extends Model<IMailrailDripStep & IBaseAttributes> {
  public readonly className = 'MailrailDripStep';

  public get constraints(): TConstraints<IMailrailDripStep & IBaseAttributes> {
    return {
      ...triggerableMailingConstraints,
      name: {
        presence: {
          allowEmpty: false,
        },
        format: {
          pattern: REGEX_INPUT_VALIDATION,
          flags: 'i',
          message: '^Step name must consist of letters, numbers, and basic symbols.',
        },
      },
      step_id: {
        presence: {
          allowEmpty: false,
        },
        format: {
          pattern: '[a-zA-Z0-9]+',
          message: '^Step ID can only contain letters and numbers.',
        },
      },
      trigger_action: {
        presence: {
          allowEmpty: false,
          message: "^Step targeting can't be blank.",
        },
      },
    };
  }
}
